module.exports = __webpack_public_path__ + "img/maintop.33b6f86.png";